/*
    Font activation on load based on code from:
        http://www.filamentgroup.com/lab/font-events.html (Copyright (c) 2015 Filament Group)
    
    Dependencies:
    - FontFaceObserver https://github.com/bramstein/fontfaceobserver
*/
(function (w) {
    'use strict';
    
    var fontsets = [{
            fonts: {
                'Open Sans': [
                    { 'weight': 700 },
                ],
                'Raleway': [
                    { 'weight': 300 },
                    { 'weight': 500 },
                    { 'weight': 800 },
                ]
            },
            activeClass: 'wf-active',
            cacheKey: 'tiffinbox-wf-cached',
        },{
            fonts: {
                'Merriweather': [
                    { 'weight': 300 },
                    { 'weight': 400 },
                    { 'weight': 700 },
                ]
            },
            activeClass: 'wf2-active',
            cacheKey: 'tiffinbox-wf2-cached',
        },{
            fonts: {
                'Raleway': [
                    { 'weight': 300, 'style': 'italic' },
                    { 'weight': 500, 'style': 'italic' },
                ],
                'Merriweather': [
                    { 'weight': 300, 'style': 'italic' },
                ]
            },
            activeClass: 'wf3-active',
            cacheKey: 'tiffinbox-wf3-cached',
        }],
        timeout = 5*60*1000; // give it 5 mins before timing out
    
    // hasClass polyfill from http://youmightnotneedjquery.com/#has_class
    function hasClass(el, className) {
        if (el.classList) {
            return el.classList.contains(className);
        }
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }
    
    function loadFonts(fontsets) {
        
        // get the first fontset
        if (fontsets.length === 0) return;
        var config = fontsets.shift();
        
        function activate() {
            // add a class to the document indicating the fonts have loaded
            w.document.documentElement.className += ' ' + config.activeClass;
            
            // set a flag to optimise future visits
            if (isSessionStorageSupported()) sessionStorage.setItem(config.cacheKey, true);
            
            // recurse over remaining fontsets
            loadFonts(fontsets);
            
            // fire resize event to trigger dimension recalculations
            $(window).resize();
        }
        
        // if the class is already set, we're good.
        if (hasClass(w.document.documentElement, config.activeClass)) return activate();
        
        // if the fonts are already cached by the browser, activate them
        if (isSessionStorageSupported() && sessionStorage.getItem(config.cacheKey)) return activate();
        
        // loop over font list and create an observer for each weight
        var observers = [];
        Object.keys(config.fonts).forEach(function (fontFamily) {
            config.fonts[fontFamily].forEach(function (fontProperties) {
                var new_observer = new w.FontFaceObserver(fontFamily, fontProperties);
                observers.push(new_observer.load(null, timeout));
            });
        });
        w.Promise.all(observers).then(activate);
    }
    
    loadFonts(fontsets);
}(this));



function initSlideshows() {
    if (window.swipeInstances) {
        window.swipeInstances.each(function () {
            $(this).data('Swipe').kill();
        });
    }
    window.swipeInstances = $('.swipe').Swipe();
    
    if (!window.initSwipeClicks) {
        window.initSwipeClicks = true;
        $('html').on('click', '.swipe-prev,.swipe-next', function () {
            var $button = $(this),
                swipe = $button.closest('.swipe-parent').find('.swipe').data('Swipe');
            if ($button.is('.swipe-prev')) {
                swipe.prev();
            } else {
                swipe.next();
            }
        });
        $(window).on('resize', function () {
            $('.arrow-bookends').each(function () {
                var $o = $(this),
                    $parent = $o.closest('.swipe-parent'),
                    $figure = $parent.find('figure').first(),
                    $image = $figure.find('img').first(),
                    setArrowHeight = function () {
                        // loop over thrice giving time for
                        // the image to resize and calculate dimensions
                        // which sometimes happens instantly, sometimes does not
                        var iteration = 0,
                            loop = setInterval(function () {
                                iteration++;
                                $o.css('top', parseInt($figure.css('marginTop'), 10) + $image.height()*1/2);
                                if (iteration === 3) { clearInterval(loop); }
                            }, 200);
                    };
                if ($image.height()) {
                    setArrowHeight();
                } else {
                    $image.on('load', setArrowHeight);
                }
            });
        }).resize();
    } else {
        $(window).resize();
    }
}
function lazyloadPhotoswipe() {
    if (!window.photoswipe_sources || !!window.PhotoSwipe) return;
    
    $.cachedScript(window.photoswipe_sources.js).done(function () {
        initImageZoom();
    });
    $.each(window.photoswipe_sources.css, function (_, src) {
        $('<link/>', {
           rel: 'stylesheet',
           type: 'text/css',
           href: src
        }).appendTo('head');
    });
}

function resetModals() {
    var modal_class = 'show-modal';
    $('body').removeClass(modal_class);
}
function initNav() {
    var toggle_selector = '.nav-toggle',
        nav_active_class = 'nav-active',
        modal_class = 'show-modal',
        $nav,
        $header,
        $title,
        $subtitle = false,
        $toggle;
    
    $('html').on('click', toggle_selector, toggleNav);
    
    function cacheSelectors() {
        $nav = $('.fullscreen-nav');
        $header = $('.section-header');
        $title = $header.find('h1');
        $toggle = $(toggle_selector);
    }
    function toggleNav(e) {
        if (!$toggle || $toggle.get(0) !== $(toggle_selector).get(0)) cacheSelectors();
        
        if ($nav.is(':hidden')) showNav();
        else hideNav();
        e.preventDefault();
    }
    function showNav() {
        $nav.show();
        $('body').addClass(modal_class);
        $('html').on('keyup.hidenav', function (e) {
            if (e.keyCode === 27) { // esc key
                hideNav();
            }
        });
        
        if ($subtitle === false) {
            $subtitle = $('<h2> Menu</h2>').addClass($title.attr('class'));
        }
        $title.after($subtitle);
        $toggle.addClass(nav_active_class).find('span').text('Close');
    }
    function hideNav() {
        $nav.hide();
        $toggle.removeClass(nav_active_class).find('span').text('Menu');
        $subtitle.remove();
        $('body').removeClass(modal_class);
        $('html').off('keyup.hidenav');
    }
}
function getCurrentWindowScrollPosition() {
    return window.scrollY !== undefined ? window.scrollY : ((window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop);
}
function initActiveEntryScroll() {
    if (window.initializedActiveEntryScroll) {
        $(window).resize();
        return;
    }
    window.initializedActiveEntryScroll = true;
    
    var listing_rows = [],
        header_height = 0,
        $window = $(window),
        $header = $('.section-header'),
        $classUpdates = $(),
        activeClass = '',
        oldClass = '',
        lastScrollTop = 0,
        didScroll = false,
        scrollPositionLoop = null,
        queued = false;
    
    function cacheScrollPosition() {
        if (didScroll) {
            lastScrollTop = getCurrentWindowScrollPosition();
            didScroll = false;
            
            if (!queued && listing_rows.length) {
                // find the last row less than current scroll position
                for (
                    var i = 0;
                    i < listing_rows.length && listing_rows[i].offsetTop < lastScrollTop + header_height;
                    i++
                );
                activeClass = listing_rows[Math.max(0, i-1)].class;
                
                // update active class
                if (oldClass !== activeClass) {
                    if (window.requestAnimationFrame) {
                        queued = true;
                        window.requestAnimationFrame(updateActiveEntry);
                    } else {
                        updateActiveEntry();
                    }
                }
            }
        }
    }
    
    function updateActiveEntry() {
        $classUpdates.addClass(activeClass).removeClass(oldClass);
        oldClass = activeClass;
        queued = false;
    }
    
    function cacheRows() {
        header_height = $header.outerHeight();
        listing_rows = [];
        $('.thumb-container .entry-teaser').each(function () {
            var $o = $(this),
                row = {
                    offsetTop: $o.offset().top,
                    class: $o.data('tbEntryClass'),
                };
            if (listing_rows.length === 0 || listing_rows[listing_rows.length-1].offsetTop < row.offsetTop) {
                listing_rows.push(row);
            }
        });
    }
    
    function contentChange() {
        cacheRows();
        if ($('.thumb-container').length !== 0) {
            $classUpdates = $('.section-header.brand-active, .section-header .brand-active, .fullscreen-nav .brand-active');
            scrollPositionLoop = setInterval(cacheScrollPosition, 250);
            $window.on('scroll.updateActiveEntry', function () { didScroll = true; });
            updateActiveEntry();
        } else {
            $window.off('scroll.updateActiveEntry');
            if (scrollPositionLoop) clearInterval(scrollPositionLoop);
        }
    }
    
    $window.on('resize.updateActiveEntry', contentChange);
    
    contentChange();
}
function initDetailPage() {
    if (!window.initializedDetailPage) {
        window.initializedDetailPage = true;
        $(window).on('resize', function () {
            var $poster = $('.entry-poster'),
                $intro = $('.entry-intro');
            if ($poster.length && $intro.length) {
                // figure out if in two column mode
                var two_column =
                    window.matchMedia ?
                        window.matchMedia('(min-width: 64em)').matches
                    :   $(window).width() > 1024;
                $poster.css('paddingTop', two_column ? $intro.position().top : 0);
            }
        }).resize();
    } else {
        $(window).resize();
    }
}
function initIndex() {
    var reorderTriggerSelector = '.trigger-index-listby',
        activeTriggerClass = 'active',
        activeTriggerSelector = '.' + activeTriggerClass,
        reorderCriteriaKey = 'tbListby',
        indexTypeSelectorPrefix = '.index-type-',
        indexTypeKey = 'tbIndexType';
    
    function getDB(indexType) {
        if (!window.tb_index || window.tb_index.length === 0) return false;
        if (!window.tb_index[indexType] || window.tb_index[indexType].length === 0) return false;
        return window.tb_index[indexType];
    }
    
    function reorderIndexBy(indexType, groupBy) {
        var DB = getDB(indexType),
            indexTypeSelector = indexTypeSelectorPrefix + indexType + ' ';
        if (DB) {
            // check if already in the requested state
            if ($(indexTypeSelector + reorderTriggerSelector + activeTriggerSelector).data(reorderCriteriaKey) === groupBy) {
                // console.log('aborting reorder request because already ordered by ' + groupBy);
                return;
            }
            
            // perform a groupBy
            var groups = {};
            $.each(DB, function (i, entry) {
                if (groupBy in entry) {
                    $.each(entry[groupBy], function (slug, value) {
                        if (typeof slug == 'number') { slug = value + ''; }
                        groups[slug] = groups[slug] || {
                            "title": value,
                            "slug": slug,
                            "entries": []
                        };
                        groups[slug].entries.push(entry);
                    });
                }
            });
            groups = $.map(groups, function (v) { return [v]; });
            groups.sort(function (a, b) {
                a = groupBy == 'year' ? parseInt(a.slug, 10) * -1 : a.slug;
                b = groupBy == 'year' ? parseInt(b.slug, 10) * -1 : b.slug;
                return a < b ? -1 : (a > b ? 1 : 0);
            });
            
            // Render HTML by cloning from existing index
            var $oldIndex = $(indexTypeSelector + '.index-list'),
                $newIndex = $oldIndex.clone().empty(),
                $emptyTitle = $oldIndex.find('dt').eq(0).clone(),
                $emptyList  = $oldIndex.find('dd').eq(0).clone();
                
            $emptyTitle.text('');
            $emptyList.find('ul').empty();
            
            $.each(groups, function (group_index, group) {
                var $title = $emptyTitle.clone(),
                    $list  = $emptyList.clone();
                
                group.entries.sort(function(a, b) {
                  return b.year[0] < a.year[0] ? -1 : (b.year[0] > a.year[0] ? 1 : 0);
                });
                $title.text(group.title);
                $title.attr('id', group.slug + '-' + indexType + '-group');
                $.each(group.entries, function (i, entry) {
                    $list.find('ul').append( $oldIndex.find(entry.selector).eq(0).clone() );
                });
                
                $newIndex
                    .append($title)
                    .append($list);
            });
            
            // Toggle show/hide of groupBy meta values
            $newIndex.find('.meta-list dd').show().filter('.listby-' + groupBy).hide();
            
            // Insert in DOM
            $oldIndex.replaceWith($newIndex);
            
            // Update active criteria
            $(indexTypeSelector + reorderTriggerSelector + activeTriggerSelector).removeClass(activeTriggerClass);
            $(indexTypeSelector + '.index-criteria-' + groupBy).addClass(activeTriggerClass);
        }
    }
    
    $('html').on('click', reorderTriggerSelector, function () {
        reorderIndexBy($(this).data(indexTypeKey), $(this).data(reorderCriteriaKey));
    });
    $('html').on('click', '.trigger-index-scroll', function () {
        var target = $(this).data('tbScrollto');
        // wait for new index groups to be rendered
        window.setTimeout(function () {
            var $target = $(target),
                $header = $('.section-header');
            if ($target.length) {
                var maxScroll = $('body').outerHeight() - $(window).height();
                var currentPos = getCurrentWindowScrollPosition();
                var targetPos = Math.min(maxScroll, $target.offset().top - $header.outerHeight() - 10);
                var duration = Math.min(Math.abs(currentPos - targetPos) / 1.5, 400);
                $('html, body').animate({
                    scrollTop: targetPos,
                }, {
                    duration: duration,
                    easing: 'swing',
                });
            }
        }, 10);
    });
}
function recordAnalytics() {
    if (window.ga) {
        window.ga('set', 'page', window.location.pathname);
        window.ga('send', 'pageview');
    }
}


function main(isInitialLoad) {
    resetModals();
    if (isInitialLoad) {
        initNav();
        initIndex();
    } else {
        recordAnalytics();
    }
    initActiveEntryScroll();
    initDetailPage();
    initSlideshows();
    lazyloadPhotoswipe();
}



// call main on Pjax load
document.addEventListener('pjax:success', function () {
    main(false);
});
// call main on initial load
$(main);
